const dateHelper = {
    /**
     * Returns 0-based index of the day of the week, starting with monday by default.
     * @param {Date} date
     * @param {string} firstDay
     */
    dayOfWeek: (date, firstDay) => {
        var daysOfWeek = {
            sunday: 0,
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
        };
        firstDay = firstDay || "monday";
        var day = date.getDay() - daysOfWeek[firstDay];
        return (day < 0 ? day + 7 : day);
    },

    isToday: (someDate) => {
        const today = new Date();
        return someDate.getDate() == today.getDate() &&
            someDate.getMonth() == today.getMonth() &&
            someDate.getFullYear() == today.getFullYear();
    }
};

const stringHelper = {
    /**
    * Returns 0-based index of the day of the week, starting with monday by default.
    * @param {string} s
    */
    capitalize: (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }
};